module.exports = __webpack_public_path__ + "static/media/tree_27.4441de06.jpeg";